<div class="search-container">
  <div [class]="searchStyle">
    <ng-content select="[checkboxFilter]"></ng-content>
    <nb-form-field class="search-form-field" *ngIf="formControl">
      <input nbInput [formControl]="formControl" [placeholder]="placeholder">
      <nb-icon nbSuffix icon="search-outline" pack="eva" *ngIf="!searchText"></nb-icon>
    </nb-form-field>
    <ng-content select="[nextToSearch]"></ng-content>
  </div>
</div>

